<template>
  <MaskComponent dialogType="history" v-show="this.$bus.historyDialogShow">
    <div class="dialog-history">
      <div class="dialog-history-title">{{ $bus.transify['FESTA_HISTORY'] }}</div>
      <div class="dialog-history-content" v-show="$bus.historyDialogList.length">
        <HistoryItem v-for="(item, index) in $bus.historyDialogList" :key="index" :item="item" />
      </div>
    </div>
  </MaskComponent>
</template>

<script>
import MaskComponent from '@/components/base/mask'
import HistoryItem from './item'

export default {
  components: {
    MaskComponent,
    HistoryItem
  }
}
</script>

<style lang="scss" scoped>
.dialog-history-title {
  @include px2res(padding-bottom, 12);
  text-align: center;
  color: #FFCE3B;
  @include px2res(font-size, 36);
  font-family: $main-font-family;
}
.dialog-history-content {
  @include px2res(height, 378);
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/history/index.vue